import Vue from "vue";
// Photoswipe Gallery
import Photoswipe from "vue-pswipe";
import Vuex from "vuex";
import "./api/axios";
import App from "./App.vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";

import router from "./router";
import store from "./store/index";

Vue.use(Vuex);

Vue.config.productionTip = false;

Vue.use(Photoswipe);
Vue.use(VueSweetalert2);

// plugin setup
Vue.use(DashboardPlugin);

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");

// createApp(App).use(store).mount('#app')
